import styled from "styled-components";
import { H2, P } from "@/lib/styles";

export const Center = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 7.5rem 0 5rem;

  ${({ theme }) => theme.mediaQueries.tablet} {
    max-width: 30rem;
    margin: 0 auto;
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    padding: 10rem 0 5rem;
  }
`;

export const Title = styled(H2)`
  margin-bottom: 1rem;
  ${({ theme }) => theme.mediaQueries.tablet} {
    margin-bottom: 1.5rem;
  }
`;

export const Subtitle = styled(P)`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1rem 0;
  margin-bottom: 1rem;
`;
